import { createFileRoute } from '@tanstack/react-router'

// e2e fixture (spec 2026-10-06-09): a page that throws on render, inside the
// application shell.
export const Route = createFileRoute('/$org/test-crash')({
  component: CrashingPage,
})

function CrashingPage(): never {
  throw new Error('Intentional test crash')
}
